(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SpadPrint", [], factory);
	else if(typeof exports === 'object')
		exports["SpadPrint"] = factory();
	else
		root["SpadPrint"] = factory();
})(window, function() {
return 